import { useState } from "react";
import { useTranslation } from "react-i18next";
import SEO from "@/components/SEO";
import BackgroundGradient from "@/components/landing/BackgroundGradient";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import ContactModal from "@/components/landing/ContactModal";
import ClientSlotsWidget from "@/components/landing/ClientSlotsWidget";
import PricingSection from "@/components/landing/PricingSection";

export default function PricingPage() {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();
  const faqs = [
    { q: t("pages.pricing.faqs.sparkQ"),   a: t("pages.pricing.faqs.sparkA")   },
    { q: t("pages.pricing.faqs.launchQ"),  a: t("pages.pricing.faqs.launchA")  },
    { q: t("pages.pricing.faqs.upgradeQ"), a: t("pages.pricing.faqs.upgradeA") },
    { q: t("pages.pricing.faqs.customQ"),  a: t("pages.pricing.faqs.customA")  },
  ];
  return (
    <>
      <SEO title="Our Packages, Dyna Agency" description="Dyna Agency web design and SEO/GEO packages for local businesses. Flexible tiers for every stage of growth." path="/packages" />
      <BackgroundGradient />
      <div style={{ minHeight: "100vh", color: "var(--dyna-fg)", position: "relative", zIndex: 1 }}>
        <Navbar onCTA={() => setModalOpen(true)} activePage="packages" />
        <main style={{ paddingTop: 120 }}>
          {/* Page hero */}
          <section style={{ padding: "var(--s-xl) var(--site-px) var(--s-lg)", maxWidth: "var(--site-max)", margin: "0 auto" }}>
            <span className="eyebrow" style={{ display: "block", marginBottom: 8 }}>{t("pages.pricing.eyebrow")}</span>
            <h1 style={{
              fontFamily: "Coolvetica, system-ui, sans-serif",
              fontSize: "clamp(48px, 7vw, 80px)", fontWeight: 700,
              letterSpacing: "0.05em", textTransform: "uppercase",
              margin: "0 0 20px", lineHeight: 1.05,
            }}>
              {t("pages.pricing.title")}
            </h1>
            <p style={{
              fontFamily: "Geist, system-ui, sans-serif", fontWeight: 300,
              fontSize: 18, lineHeight: 1.7, color: "var(--dyna-fg-muted)", maxWidth: 560,
            }}>
              {t("pages.pricing.subtitle")}
            </p>
            <div style={{ marginTop: 24 }}>
              <ClientSlotsWidget />
            </div>
          </section>

          {/* Pricing section */}
          <PricingSection onCTA={() => setModalOpen(true)} />

          {/* FAQ */}
          <section style={{ padding: "var(--s-xl) var(--site-px)", maxWidth: "var(--site-max)", margin: "0 auto" }}>
            <div style={{ textAlign: "center", marginBottom: 48 }}>
              <span className="eyebrow" style={{ display: "block", marginBottom: 8, color: "var(--color-secondary, var(--lavender-500))" }}>
                {t("pages.pricing.faqEyebrow")}
              </span>
              <h2 style={{
                fontFamily: "Coolvetica, system-ui, sans-serif",
                fontSize: "clamp(32px, 4vw, 48px)", fontWeight: 700,
                letterSpacing: "0.05em", textTransform: "uppercase",
                lineHeight: 1.1, margin: "0 0 12px", color: "var(--dyna-fg)",
              }}>
                {t("pages.pricing.faqTitle")}
              </h2>
            </div>
            <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", flexDirection: "column", gap: 16 }}>
              {faqs.map((faq) => (
                <div key={faq.q} style={{
                  padding: "24px 28px", borderRadius: 16,
                  border: "1px solid var(--dyna-border)",
                  background: "var(--dyna-bg-elevated)",
                }}>
                  <h3 style={{
                    fontFamily: "Geist, system-ui, sans-serif",
                    fontSize: 16, fontWeight: 600, color: "var(--dyna-fg)",
                    margin: "0 0 10px", letterSpacing: 0,
                  }}>
                    {faq.q}
                  </h3>
                  <p style={{ fontSize: 15, lineHeight: 1.65, color: "var(--dyna-fg-muted)", margin: 0 }}>
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </section>
        </main>
        <Footer />
      </div>
      <ContactModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}
